import React from 'react';
import { env } from 'next-runtime-env';
import { TableCell } from '@leasequery/lq.react-component-library/dist/components/table';
import * as Styled from './styled';

interface ReportLeaseDescriptionColumnProps {
  cell: TableCell;
}

interface LeaseDescription {
  url?: string;
  label: string;
}
const parseLeaseDescription = (leaseDescription: string): LeaseDescription => {
  if (!document) return { label: leaseDescription };
  const elem = document.createElement('div');
  elem.innerHTML = leaseDescription;
  const aElem = elem.firstChild as HTMLAnchorElement;

  if (!aElem || aElem.nodeName !== 'A')
    return { url: '', label: leaseDescription };

  return {
    url: `${env('NEXT_PUBLIC_LQ_ROOT_URL')}${aElem.getAttribute('href')}`,
    label: aElem.innerText.trim(),
  };
};

function ReportLeaseDescriptionColumn({
  cell,
}: ReportLeaseDescriptionColumnProps): JSX.Element {
  const leaseDescription = parseLeaseDescription(cell.value);
  return leaseDescription.url ? (
    <Styled.LeaseDescription
      href={leaseDescription.url}
      title={leaseDescription.label}
    >
      {leaseDescription.label}
    </Styled.LeaseDescription>
  ) : (
    <>{leaseDescription.label}</>
  );
}

export default ReportLeaseDescriptionColumn;
